export function getErrorMsg(errorResponse: any): string {
  const { error } = errorResponse;
  return error &&
    Object.hasOwn(error, 'friendly_message') &&
    error['friendly_message'] !== null
    ? error['friendly_message']
    : error?.message || errorResponse?.message;
}
